import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// Pages
import TwoFactorRegisterPage from "pages/TwoFactorRegisterPages/TwoFactorRegisterPage/TwoFactorRegisterPage";
import LoggingOutPage from "pages/LoggingOutPage/LoggingOutPage";
import LoadingPage from "pages/LoadingPage/LoadingPage";

// Actions
import { isSignedIn } from "store/slices/accountSlice";
import { setContent } from "store/slices/applicationSlice";
import { setLoader } from "store/slices/loadersSlice";

export default function TwoFactorRegisterPages() {
  const { content } = useSelector(({ application }) => application);
  const { isLoader } = useSelector(({ loaders }) => loaders);

  // Redux
  const reduxDispatch = useDispatch();

  // Constants
  const PAGES = Object.freeze({
    TwoFactorRegisterPage: <TwoFactorRegisterPage />,
    LoggingOutPage: <LoggingOutPage />,
  });

  useEffect(() => {
    reduxDispatch(isSignedIn()).then(result => {
      const { signedIn } = result.payload;
      const redirectToPage = signedIn ? "TwoFactorRegisterPage" : "LoggingOutPage";

      reduxDispatch(setContent(redirectToPage));
      reduxDispatch(setLoader(false));
    });
  }, []);

  return isLoader ? (
    <LoadingPage title="Welcome" content="Checking your details" />
  ) : (
    PAGES[content]
  );
}
